import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';


@Component({
  selector: 'itc-formly-timepicker',
  template: `
    {{ props.label }}
    @if (props.required && props.hideRequiredMarker !== true) {
      <span
        aria-hidden="true"
        class="mat-form-field-required-marker"
        >*</span
        >
      }
      <ngx-mat-timepicker
        [formControl]="control"
        [id]="id"
        [color]="props.color"
        [formlyAttributes]="field"
        [tabIndex]="props.tabindex"
        >
      </ngx-mat-timepicker>
      <span>Format (hh:mm)</span>
    `,
  styleUrls: ['./formly-timepicker.component.scss'],
  imports: [FormlyModule, ReactiveFormsModule, NgxMatTimepickerModule],
})
export class TimepickerComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  control: UntypedFormControl;

  ngOnInit() {
    this.control = this?.formControl as UntypedFormControl;
  }
}
